import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import HurricaneCallout from "../components/HurricaneCallout";
import WhyUs from "../components/WhyUs";
import Process from "../components/Process";
import ServiceAreas from "../components/ServiceAreas";
import CTAStrip from "../components/CTAStrip";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import CalculatorCallout from "../components/CalculatorCallout";
import { faqs } from "../mock";
import {
  localBusinessSchema,
  faqSchema,
  breadcrumbSchema,
} from "../utils/schemas";

const HomePage = () => {
  const schemas = [
    localBusinessSchema(),
    faqSchema(faqs),
    breadcrumbSchema([{ name: "Home", path: "/" }]),
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      url: "https://claimbeast.com",
      name: "Claim Beast Public Adjusters",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://claimbeast.com/?s={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
  ];

  return (
    <div className="bg-black min-h-screen text-white antialiased">
      <SEO
        title="Claim Beast Public Adjusters | Tampa Bay & Riverview FL | Free Claim Review"
        description="Tampa Bay public adjusters fighting denied & underpaid insurance claims. Based in Riverview, FL. We handle hurricane, fire, flood, hail, water and mold claims across Tampa, Brandon, Apollo Beach & all Tampa Bay cities. Free claim review. No win, no fee."
        path="/"
        keywords="public adjuster Tampa, public adjuster Riverview FL, denied insurance claim Tampa, hurricane damage claim Florida, public adjusters Tampa Bay, Brandon FL public adjuster, Apollo Beach claims, roof damage claim Tampa, flood claim Tampa, fire damage claim Florida, hail damage claim Tampa, water damage claim Tampa, mold damage claim, insurance claim help Tampa"
        schemas={schemas}
      />
      <Header />
      <main>
        <Hero />
        <Services />
        <HurricaneCallout />
        <WhyUs />
        <Process />
        <CalculatorCallout
          eyebrow="Before You Pick Up The Phone"
          headline="Find Out What Your Claim Is Worth — In 60 Seconds."
          body="You don't need to call us blind. Walk through a few quick questions about your damage and we'll calculate a defensible recovery range using current Florida market rates. Then we'll follow up to fight for every dollar."
          ctaLabel="Run My Estimate"
        />
        <CTAStrip />
        <ServiceAreas />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
